module.exports = __webpack_public_path__ + "img/16.6f7cbca9.jpg";